import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Home',
    href: '#hero'
  }, {
    name: 'Free Predictions',
    href: '#predictions'
  }, {
    name: 'VIP Access',
    href: 'https://greenhsvip.site/',
    external: true
  }, {
    name: 'Latest Updates',
    href: '#updates'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-dark-base/95 backdrop-blur-md border-b border-neon-cyan/20" data-id="element-141">
      <div className="container mx-auto px-4" data-id="element-142">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-143">
          {/* Logo */}
          <a href="#hero" className="flex items-center" data-id="element-144">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/18uUj75sqKx1JvC2VjYx24/IMG_0740_3.png" alt="GreenHS Logo" className="h-12 md:h-10 w-auto" data-id="element-145" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-146">
            {navLinks.map(link => <a key={link.name} href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noopener noreferrer' : undefined} className="text-sm font-semibold text-gray-300 hover:text-neon-cyan transition-colors" data-id="element-147">
                {link.name}
              </a>)}
            <a href="https://greenhsvip.site/" target="_blank" rel="noopener noreferrer" className="px-6 py-2 bg-gradient-to-r from-neon-cyan to-cyan-600 rounded-lg font-bold text-sm text-white hover:shadow-[0_0_20px_rgba(6,182,212,0.5)] transition-all" data-id="element-148">
              Join VIP 🌟
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-white hover:text-neon-cyan transition-colors" aria-label="Toggle menu" data-id="element-149">
            {isMenuOpen ? <XIcon className="w-6 h-6" data-id="element-150" /> : <MenuIcon className="w-6 h-6" data-id="element-151" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-152">
        {isMenuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="md:hidden overflow-hidden bg-dark-card/95 backdrop-blur-md border-t border-neon-cyan/20" data-id="element-153">
            <div className="container mx-auto px-4 py-4 space-y-3" data-id="element-154">
              {navLinks.map(link => <a key={link.name} href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noopener noreferrer' : undefined} onClick={() => setIsMenuOpen(false)} className="block py-3 px-4 text-base font-semibold text-gray-300 hover:text-neon-cyan hover:bg-neon-cyan/10 rounded-lg transition-all" data-id="element-155">
                  {link.name}
                </a>)}
              <a href="https://greenhsvip.site/" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="block py-3 px-4 bg-gradient-to-r from-neon-cyan to-cyan-600 rounded-lg font-bold text-base text-white text-center" data-id="element-156">
                Join VIP 🌟
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}